import { apiService } from "./index";

const taxonomyService = {
  search(term) {
    return apiService.get(`/taxonomies/search?term=${encodeURIComponent(term)}`);
  },

  getAll() {
    return apiService.get("/taxonomies");
  },
};

export { taxonomyService };
